/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: (props) => ({
        backgroundContainer: {
            paddingBottom: '50px',
            background:
                props.backgroundTheme === 'transparent/black'
                    ? 'linear-gradient(to bottom, white 50%, black 50%)'
                    : props.backgroundTheme === 'black/transparent'
                      ? 'linear-gradient(to bottom, black 50%, white 50%)'
                      : 'transparent'
        },
        videoContainer: {
            maxWidth: '1100px',
            margin: '0 auto',
            px: [4, 4, 6, 6, 8, 0]
        },
        outerTextContainer: {
            background: props.backgroundTheme === 'transparent/black' ? 'black' : 'transparent',
            paddingBottom: '50px',
            marginTop: '-1px'
        },
        textContainer: {
            maxWidth: '1100px',
            margin: '0 auto',
            px: [4, 4, 6, 6, 8, 0],
            color: props.textColor,
            textAlign: 'justify'
        }
    }),
    variants: {},
    parts: ['videoContainer', 'outerTextContainer', 'textContainer']
}
